import script from "./LibrarianEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LibrarianEdit.vue?vue&type=script&setup=true&lang=js"

import "./LibrarianEdit.vue?vue&type=style&index=0&id=b6ec62fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ec62fe"]])

export default __exports__